import { ChevronDown } from "lucide-react";
import "./Introduction.css";

// Hero Section
export default function Introduction({ images }) {
  return (
    <section
      id="home"
      className="intro-section relative"
      data-testid="intro-section"
    >
      <div className="intro-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <div className="animate-fade-in-up">
          <h1 className="font-['Marcellus'] text-4xl sm:text-6xl lg:text-7xl text-[#F0E6D2] tracking-tight mb-6">
            Cleo Buenaventura
          </h1>
          <p className="text-[#0AC8B9] text-xl sm:text-2xl uppercase tracking-widest mb-8">
            Software Developer
          </p>
          <p className="text-[#A09B8C] text-lg max-w-2xl mx-auto mb-12 leading-relaxed">
            I design and build full-stack applications, turning complex problems
            into efficient, user-focused solutions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#skills"
              className="btn-magic w-52 text-center whitespace-nowrap"
            >
              Abilities
            </a>
            <a
              href="#contact"
              className="btn-metal w-52 text-center whitespace-nowrap"
            >
              Send Message
            </a>
          </div>
        </div>
      </div>

      <a
        href="#about"
        className="absolute bottom-20 inset-x-0 flex justify-center animate-bounce"
      >
        <ChevronDown className="text-[#C89B3C]" size={32} />
      </a>
    </section>
  );
}
